module.exports = __webpack_public_path__ + "static/media/Logo_Orginal.1e9dcdd9.png";